export default function HeroSection() {
  return (
    <section className="relative h-[480px] md:h-[560px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Luxurious%20modern%20residential%20home%20exterior%20at%20dusk%20with%20warm%20glowing%20lights%20inside%20through%20large%20floor%20to%20ceiling%20windows%2C%20elegant%20minimalist%20architecture%20with%20clean%20lines%20and%20premium%20materials%2C%20beautifully%20landscaped%20garden%20with%20soft%20warm%20outdoor%20lighting%2C%20cream%20colored%20facade%20with%20champagne%20gold%20accent%20details%2C%20inviting%20and%20welcoming%20atmosphere%2C%20high%20end%20real%20estate%20photography%2C%20Taiwan%20contemporary%20architecture%2C%20no%20people%20visible%2C%20peaceful%20upscale%20neighborhood%20setting&width=1440&height=560&seq=contact-hero-2026&orientation=landscape"
          alt="聯繫我們 - 高端住宅諮詢"
          className="w-full h-full object-cover object-center"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/55" />
      </div>

      <div className="relative z-10 container-main w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-3xl">
          <span className="inline-block px-4 py-1.5 bg-champagne/20 backdrop-blur-sm text-champagne text-base font-semibold tracking-wider rounded-full mb-5">
            CONTACT US
          </span>
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-cream leading-tight mb-5">
            聯繫我們
          </h1>
          <p className="text-base md:text-base text-cream/85 max-w-2xl leading-relaxed mb-8">
            無論您有任何自地自建的疑問，Chronos Space 專業團隊都在這裡為您解答。歡迎透過 LINE 即時諮詢，或填寫表單預約說明會，我們將在 24 小時內與您聯繫。
          </p>
          <a
            href="https://lin.ee/OpssTIM"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-6 py-3 bg-champagne text-graphite rounded-full text-base font-semibold transition-all duration-300 hover:bg-champagne/90 hover:-translate-y-0.5 whitespace-nowrap"
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-line-fill" />
            </span>
            加入 LINE 諮詢
          </a>
        </div>
      </div>
    </section>
  );
}